module.exports = __webpack_public_path__ + "img/player1.144e18ed.svg";